export { PageDashboardComponent as PageDashboard } from './component';
import "./index.scss"


// WEBPACK FOOTER //
// ./src/pages/dashboard/index.tsx